import {useEffect, useMemo, useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setLotsData} from "../../redux/lots/action";
import {getFilters, setFilters} from "../../redux/sidebars/filter-sidebar/actionFilterSideBar";
import {getQueryLinkParams} from "../../helpers/routing-helper";
import useBreadCrumbsMainPage from "../global-hooks/breadcrums-hooks/useBreadCrumbsMainPage";
import useBreadCrumbsOtherPage from "../global-hooks/breadcrums-hooks/useBreadCrumbsOtherPage";
import {useLocation} from "react-router-dom";
import {clearChangeLot, toggleModal} from "../../redux/modals/modal-inline-mod-check/actionModal";
import useLotsDataWatcher from "../global-hooks/breadcrums-hooks/useLotsDataWatcher";

const useLotsFn = () => {
    const dispatch = useDispatch();

    const location = useLocation();
    const {search: urlSearch, pathname} = location;

    // Мемоизированный селектор для предотвращения лишних рендеров
    const {startLoading, simulateLoading, user_sort_data, changeLots} = useSelector(state => ({
        startLoading: state.lots.startLoading,
        simulateLoading: state.lots.simulateLoading,
        user_sort_data: state.lots.user_sort_data,
        changeLots: state.modal.changeLots
    }), (prev, next) => {
        // Кастомная функция сравнения для shallowEqual
        return prev.startLoading === next.startLoading &&
               prev.simulateLoading === next.simulateLoading &&
               prev.user_sort_data === next.user_sort_data &&
               prev.changeLots === next.changeLots;
    });

    // Мемоизированный query параметр
    const {user_lots_type = ''} = useMemo(() => getQueryLinkParams(user_sort_data), [user_sort_data, urlSearch, pathname]);

    // Мемоизированная функция инициализации
    const initializeData = useCallback(async () => {
        const filters = await dispatch(getFilters());
        await dispatch(setFilters(filters));
        await dispatch(setLotsData());
    }, [dispatch]);

    useEffect(() => {
        initializeData();
    }, [urlSearch, pathname, initializeData]);

    useLotsDataWatcher()
    useBreadCrumbsMainPage();
    useBreadCrumbsOtherPage();

    // Мемоизированная функция для обработки модального окна
    const handleModalToggle = useCallback(() => {
        if (changeLots.length === 0) {
            dispatch(toggleModal(false));
        }
    }, [changeLots.length, dispatch]);

    // Эффект для модального окна
    useEffect(() => {
        handleModalToggle();
    }, [changeLots, handleModalToggle]);

    // Мемоизированная функция очистки
    const handleClearChangeLot = useCallback(() => {
        dispatch(clearChangeLot());
    }, [dispatch]);

    useEffect(() => {
        handleClearChangeLot();
    }, [urlSearch, pathname, handleClearChangeLot]);

    return {
        startLoading, simulateLoading, user_lots_type,
    }
}
export default useLotsFn
